var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMediumIcon = function SvgMediumIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.54 6.82C13.5453 8.62175 12.8354 10.352 11.566 11.6307C10.2967 12.9094 8.57177 13.6321 6.77003 13.64C4.96829 13.6321 3.24335 12.9094 1.97402 11.6307C0.704678 10.352 -0.00528713 8.62175 2.96483e-05 6.82C-0.00528713 5.01825 0.704678 3.28804 1.97402 2.00933C3.24335 0.730618 4.96829 0.00794108 6.77003 0C8.57177 0.00794108 10.2967 0.730618 11.566 2.00933C12.8354 3.28804 13.5453 5.01825 13.54 6.82ZM20.96 6.82C20.96 10.36 19.45 13.24 17.58 13.24C15.71 13.24 14.19 10.36 14.19 6.82C14.19 3.28 15.71 0.4 17.58 0.4C19.45 0.4 20.96 3.28 20.96 6.82ZM24 6.82C24 9.99 23.47 12.57 22.81 12.57C22.15 12.57 21.62 9.99 21.62 6.82C21.62 3.65 22.15 1.07 22.81 1.07C23.47 1.07 24 3.65 24 6.82Z",
    fill: "#0B2EFB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMediumIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium-icon.2b245e35.svg";
export { ForwardRef as ReactComponent };